import { Injectable } from '@angular/core';
import { GridError, SocieteComposantDataRow } from '@get/api-interfaces';
import { GridErrorSocieteComposantActions } from '@get/store/actions';
import { AppState } from '@get/store/configs/reducers';
import { GridErrorSocieteComposantSelectors } from '@get/store/selectors';
import { SelectSchema } from '@get/utils';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GridErrorSocieteComposantService {
  tempId = 0;
  constructor(private store$: Store<AppState>) {}

  public addOneGridError(gridErrorSocieteComposant: Partial<GridError>): number | undefined {
    if (!gridErrorSocieteComposant.error.idSocieteComposant) {
      gridErrorSocieteComposant.error.idSocieteComposant = --this.tempId;
    }
    gridErrorSocieteComposant.idGridError = gridErrorSocieteComposant.error.idSocieteComposant;
    this.store$.dispatch(
      GridErrorSocieteComposantActions.addOneGridErrorSocieteComposant({
        gridErrorSocieteComposant: gridErrorSocieteComposant as GridError
      })
    );
    return gridErrorSocieteComposant.idGridError;
  }

  public removeOneGridError(idGridError: number): void | Observable<number> {
    this.store$.dispatch(GridErrorSocieteComposantActions.deleteOneGridErrorSocieteComposantSuccess({ idGridError }));
  }

  public selectSocieteComposantAndGridErrors(schema: SelectSchema = {}): Observable<SocieteComposantDataRow[]> {
    return this.store$
      .pipe(select(GridErrorSocieteComposantSelectors.selectSocieteComposantAndGridErrors(schema)))
      .pipe(map(societeComposantDataRow => societeComposantDataRow));
  }
}
